"use client";

// packages/react/radio-group/src/radio-group.tsx
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeRadio", "name", "checked", "required", "disabled", "value", "onCheck", "form"],
  _excluded2 = ["__scopeRadio", "forceMount"],
  _excluded3 = ["control", "checked", "bubbles"],
  _excluded4 = ["__scopeRadioGroup", "name", "defaultValue", "value", "required", "disabled", "orientation", "dir", "loop", "onValueChange"],
  _excluded5 = ["__scopeRadioGroup", "disabled"],
  _excluded6 = ["__scopeRadioGroup"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React2 from "react";
import { composeEventHandlers as composeEventHandlers2 } from "@radix-ui/primitive";
import { useComposedRefs as useComposedRefs2 } from "@radix-ui/react-compose-refs";
import { createContextScope as createContextScope2 } from "@radix-ui/react-context";
import { Primitive as Primitive2 } from "@radix-ui/react-primitive";
import * as RovingFocusGroup from "@radix-ui/react-roving-focus";
import { createRovingFocusGroupScope } from "@radix-ui/react-roving-focus";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { useDirection } from "@radix-ui/react-direction";

// packages/react/radio-group/src/radio.tsx
import * as React from "react";
import { composeEventHandlers } from "@radix-ui/primitive";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope } from "@radix-ui/react-context";
import { useSize } from "@radix-ui/react-use-size";
import { usePrevious } from "@radix-ui/react-use-previous";
import { Presence } from "@radix-ui/react-presence";
import { Primitive } from "@radix-ui/react-primitive";
import { jsx, jsxs } from "react/jsx-runtime";
var RADIO_NAME = "Radio";
var _createContextScope = createContextScope(RADIO_NAME),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createRadioContext = _createContextScope2[0],
  createRadioScope = _createContextScope2[1];
var _createRadioContext = createRadioContext(RADIO_NAME),
  _createRadioContext2 = _slicedToArray(_createRadioContext, 2),
  RadioProvider = _createRadioContext2[0],
  useRadioContext = _createRadioContext2[1];
var Radio = React.forwardRef(function (props, forwardedRef) {
  var __scopeRadio = props.__scopeRadio,
    name = props.name,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    required = props.required,
    disabled = props.disabled,
    _props$value = props.value,
    value = _props$value === void 0 ? "on" : _props$value,
    onCheck = props.onCheck,
    form = props.form,
    radioProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    button = _React$useState2[0],
    setButton = _React$useState2[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setButton(node);
  });
  var hasConsumerStoppedPropagationRef = React.useRef(false);
  var isFormControl = button ? form || !!button.closest("form") : true;
  return /* @__PURE__ */jsxs(RadioProvider, {
    scope: __scopeRadio,
    checked: checked,
    disabled: disabled,
    children: [/* @__PURE__ */jsx(Primitive.button, _objectSpread(_objectSpread({
      type: "button",
      role: "radio",
      "aria-checked": checked,
      "data-state": getState(checked),
      "data-disabled": disabled ? "" : void 0,
      disabled: disabled,
      value: value
    }, radioProps), {}, {
      ref: composedRefs,
      onClick: composeEventHandlers(props.onClick, function (event) {
        if (!checked) onCheck === null || onCheck === void 0 || onCheck();
        if (isFormControl) {
          hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
          if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
        }
      })
    })), isFormControl && /* @__PURE__ */jsx(BubbleInput, {
      control: button,
      bubbles: !hasConsumerStoppedPropagationRef.current,
      name: name,
      value: value,
      checked: checked,
      required: required,
      disabled: disabled,
      form: form,
      style: {
        transform: "translateX(-100%)"
      }
    })]
  });
});
Radio.displayName = RADIO_NAME;
var INDICATOR_NAME = "RadioIndicator";
var RadioIndicator = React.forwardRef(function (props, forwardedRef) {
  var __scopeRadio = props.__scopeRadio,
    forceMount = props.forceMount,
    indicatorProps = _objectWithoutProperties(props, _excluded2);
  var context = useRadioContext(INDICATOR_NAME, __scopeRadio);
  return /* @__PURE__ */jsx(Presence, {
    present: forceMount || context.checked,
    children: /* @__PURE__ */jsx(Primitive.span, _objectSpread(_objectSpread({
      "data-state": getState(context.checked),
      "data-disabled": context.disabled ? "" : void 0
    }, indicatorProps), {}, {
      ref: forwardedRef
    }))
  });
});
RadioIndicator.displayName = INDICATOR_NAME;
var BubbleInput = function BubbleInput(props) {
  var control = props.control,
    checked = props.checked,
    _props$bubbles = props.bubbles,
    bubbles = _props$bubbles === void 0 ? true : _props$bubbles,
    inputProps = _objectWithoutProperties(props, _excluded3);
  var ref = React.useRef(null);
  var prevChecked = usePrevious(checked);
  var controlSize = useSize(control);
  React.useEffect(function () {
    var input = ref.current;
    var inputProto = window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    var setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      var event = new Event("click", {
        bubbles: bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */jsx("input", _objectSpread(_objectSpread({
    type: "radio",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps), {}, {
    tabIndex: -1,
    ref: ref,
    style: _objectSpread(_objectSpread(_objectSpread({}, props.style), controlSize), {}, {
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    })
  }));
};
function getState(checked) {
  return checked ? "checked" : "unchecked";
}

// packages/react/radio-group/src/radio-group.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
var RADIO_GROUP_NAME = "RadioGroup";
var _createContextScope3 = createContextScope2(RADIO_GROUP_NAME, [createRovingFocusGroupScope, createRadioScope]),
  _createContextScope4 = _slicedToArray(_createContextScope3, 2),
  createRadioGroupContext = _createContextScope4[0],
  createRadioGroupScope = _createContextScope4[1];
var useRovingFocusGroupScope = createRovingFocusGroupScope();
var useRadioScope = createRadioScope();
var _createRadioGroupCont = createRadioGroupContext(RADIO_GROUP_NAME),
  _createRadioGroupCont2 = _slicedToArray(_createRadioGroupCont, 2),
  RadioGroupProvider = _createRadioGroupCont2[0],
  useRadioGroupContext = _createRadioGroupCont2[1];
var RadioGroup = React2.forwardRef(function (props, forwardedRef) {
  var __scopeRadioGroup = props.__scopeRadioGroup,
    name = props.name,
    defaultValue = props.defaultValue,
    valueProp = props.value,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    orientation = props.orientation,
    dir = props.dir,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    onValueChange = props.onValueChange,
    groupProps = _objectWithoutProperties(props, _excluded4);
  var rovingFocusGroupScope = useRovingFocusGroupScope(__scopeRadioGroup);
  var direction = useDirection(dir);
  var _useControllableState = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    value = _useControllableState2[0],
    setValue = _useControllableState2[1];
  return /* @__PURE__ */jsx2(RadioGroupProvider, {
    scope: __scopeRadioGroup,
    name: name,
    required: required,
    disabled: disabled,
    value: value,
    onValueChange: setValue,
    children: /* @__PURE__ */jsx2(RovingFocusGroup.Root, _objectSpread(_objectSpread({
      asChild: true
    }, rovingFocusGroupScope), {}, {
      orientation: orientation,
      dir: direction,
      loop: loop,
      children: /* @__PURE__ */jsx2(Primitive2.div, _objectSpread(_objectSpread({
        role: "radiogroup",
        "aria-required": required,
        "aria-orientation": orientation,
        "data-disabled": disabled ? "" : void 0,
        dir: direction
      }, groupProps), {}, {
        ref: forwardedRef
      }))
    }))
  });
});
RadioGroup.displayName = RADIO_GROUP_NAME;
var ITEM_NAME = "RadioGroupItem";
var RadioGroupItem = React2.forwardRef(function (props, forwardedRef) {
  var __scopeRadioGroup = props.__scopeRadioGroup,
    disabled = props.disabled,
    itemProps = _objectWithoutProperties(props, _excluded5);
  var context = useRadioGroupContext(ITEM_NAME, __scopeRadioGroup);
  var isDisabled = context.disabled || disabled;
  var rovingFocusGroupScope = useRovingFocusGroupScope(__scopeRadioGroup);
  var radioScope = useRadioScope(__scopeRadioGroup);
  var ref = React2.useRef(null);
  var composedRefs = useComposedRefs2(forwardedRef, ref);
  var checked = context.value === itemProps.value;
  var isArrowKeyPressedRef = React2.useRef(false);
  React2.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (ARROW_KEYS.includes(event.key)) {
        isArrowKeyPressedRef.current = true;
      }
    };
    var handleKeyUp = function handleKeyUp() {
      return isArrowKeyPressedRef.current = false;
    };
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
  return /* @__PURE__ */jsx2(RovingFocusGroup.Item, _objectSpread(_objectSpread({
    asChild: true
  }, rovingFocusGroupScope), {}, {
    focusable: !isDisabled,
    active: checked,
    children: /* @__PURE__ */jsx2(Radio, _objectSpread(_objectSpread(_objectSpread({
      disabled: isDisabled,
      required: context.required,
      checked: checked
    }, radioScope), itemProps), {}, {
      name: context.name,
      ref: composedRefs,
      onCheck: function onCheck() {
        return context.onValueChange(itemProps.value);
      },
      onKeyDown: composeEventHandlers2(function (event) {
        if (event.key === "Enter") event.preventDefault();
      }),
      onFocus: composeEventHandlers2(itemProps.onFocus, function () {
        var _ref$current;
        if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
      })
    }))
  }));
});
RadioGroupItem.displayName = ITEM_NAME;
var INDICATOR_NAME2 = "RadioGroupIndicator";
var RadioGroupIndicator = React2.forwardRef(function (props, forwardedRef) {
  var __scopeRadioGroup = props.__scopeRadioGroup,
    indicatorProps = _objectWithoutProperties(props, _excluded6);
  var radioScope = useRadioScope(__scopeRadioGroup);
  return /* @__PURE__ */jsx2(RadioIndicator, _objectSpread(_objectSpread(_objectSpread({}, radioScope), indicatorProps), {}, {
    ref: forwardedRef
  }));
});
RadioGroupIndicator.displayName = INDICATOR_NAME2;
var Root2 = RadioGroup;
var Item2 = RadioGroupItem;
var Indicator = RadioGroupIndicator;
export { Indicator, Item2 as Item, RadioGroup, RadioGroupIndicator, RadioGroupItem, Root2 as Root, createRadioGroupScope };